/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* eslint-disable */
import type { GetAncestorsResponse } from '../models/GetAncestorsResponse';
import type { GetAncestorsSchema } from '../models/GetAncestorsSchema';
import type { GetBalanceResponse } from '../models/GetBalanceResponse';
import type { GetBalanceSchema } from '../models/GetBalanceSchema';
import type { GetHealthcheckResponse } from '../models/GetHealthcheckResponse';
import type { GetTonDepositInfoResponse } from '../models/GetTonDepositInfoResponse';
import type { TonTransferSchema } from '../models/TonTransferSchema';
import type { UpdateBalanceResponse } from '../models/UpdateBalanceResponse';
import type { UpdateBalanceSchema } from '../models/UpdateBalanceSchema';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class SharedService {
  /**
   * Healthcheck
   * Check the health of the service
   * @returns GetHealthcheckResponse Successful Response
   * @throws ApiError
   */
  public static healthcheckApiV1SharedHealthcheckGet(): CancelablePromise<GetHealthcheckResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/shared/healthcheck',
    });
  }
  /**
   * @deprecated
   * Get Project Logo
   * Get project logo by project id
   * @param projectId
   * @returns any Successful Response
   * @throws ApiError
   */
  public static getProjectLogoApiV1SharedProjectsProjectIdLogoGet(projectId: string): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/shared/projects/{project_id}/logo',
      path: {
        project_id: projectId,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Get Balance By Telegram Id
   * @param requestBody
   * @returns GetBalanceResponse Successful Response
   * @throws ApiError
   */
  public static getBalanceByTelegramIdApiV1SharedGetBalancePost(
    requestBody: GetBalanceSchema
  ): CancelablePromise<GetBalanceResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/shared/get_balance',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Update Balance By Telegram Id
   * @param requestBody
   * @returns UpdateBalanceResponse Successful Response
   * @throws ApiError
   */
  public static updateBalanceByTelegramIdApiV1SharedUpdateBalancePost(
    requestBody: UpdateBalanceSchema
  ): CancelablePromise<UpdateBalanceResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/shared/update_balance',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Get Ancestors
   * @param requestBody
   * @returns GetAncestorsResponse Successful Response
   * @throws ApiError
   */
  public static getAncestorsApiV1SharedGetAncestorsPost(
    requestBody: GetAncestorsSchema
  ): CancelablePromise<GetAncestorsResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/shared/get_ancestors',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Render File
   * @param filePath Filename
   * @param contentType Content type
   * @returns any Successful Response
   * @throws ApiError
   */
  public static renderFileApiV1SharedRenderFileGet(filePath: string, contentType: string): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/shared/render_file',
      query: {
        file_path: filePath,
        content_type: contentType,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Ton Transfer
   * Transfer tokens between wallets
   * @param requestBody
   * @returns void
   * @throws ApiError
   */
  public static tonTransferApiV1SharedTonTransferPost(requestBody: TonTransferSchema): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/shared/ton_transfer',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Get Ton Deposit Info
   * Get TON deposit info by address
   * @returns GetTonDepositInfoResponse Successful Response
   * @throws ApiError
   */
  public static getTonDepositInfoApiV1SharedTonDepositInfoGet(): CancelablePromise<GetTonDepositInfoResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/shared/ton/deposit_info',
    });
  }
}
